<template>
  <div id="divPaymentOption" style="font-size: small !important">
    <!-- {{ userTypeID }} : {{ ProgID }} : {{ NomAuthID }} -->
    <div class="Flex_Table tblEntryForm">
      <fieldset class="EntryBlock">
        <legend>PAYMENT DETAILS</legend>
        <div class="Flex_Table tblEntryForm">
          <div class="Flex_Row" align="center">
            <div class="Flex_Cell">
              <marquee style="width: 45%">
                <span style="font-size: 18px; color: red">
                  You will not be able to modify the nomination after clicking
                  on the payment button.
                </span></marquee
              >
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell" align="center">
              <span style="font-size: 12pt"
                ><b>Payment for Nomination Code :</b> {{ NominationCode }}</span
              >
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell" align="center">
              <div class="Flex_Table ekkGrid GridFlex">
                <div class="Flex_Row GridHeader">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Fee Type
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    Amount in
                    <span v-if="PaymentDetailsList.currency == 2"
                      >&nbsp;&#36;</span
                    >
                    <span v-else-if="PaymentDetailsList.currency == 1"
                      >&nbsp;&#x20B9;</span
                    >
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Total programme fee payable
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.grossFeeAmount }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Original Fee
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.feeAmount_ServiceTax }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    <span
                      :title="
                        '(An early bird incentive of ' +
                        PaymentDetailsList.earlyBird +
                        '% is given for those who register 15 days before the start of the programme)'
                      "
                    >
                      Early Bird Incentive
                    </span>
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.earlyBirdAmount }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Discount Amount
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.discountAmount }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 100%" align="center">
                    <b>Break up of Fee Payable:</b>
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Fees
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.actualFeeAmount }}
                  </div>
                </div>
                <div
                  class="Flex_Row GridContent tblRow"
                  v-if="PaymentDetailsList.serviceTax != 0"
                >
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Add:IGST @ {{ PaymentDetailsList.serviceTax }}%
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.serviceTaxAmount }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Add:CGST @ {{ PaymentDetailsList.cessServiceTax }}%
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.cessServiceTaxAmount }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Add:SGST @ {{ PaymentDetailsList.kK_CESSTax }}%
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.kK_CESSTaxAmount }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Gross Fees
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.grossFeeAmount }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Less: TDS @ {{ PaymentDetailsList.tds }}%
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.tdsAmount }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    Net fees to be sent to NIBM(Inclusive of GST)
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    {{ PaymentDetailsList.netFeeAmount }}
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    <b>Please Pay to NIBM</b>
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    <b>{{ PaymentDetailsList.netFeeAmount }}</b>
                  </div>
                </div>
                <div class="Flex_Row GridContent tblRow">
                  <div class="Flex_Cell" style="width: 70%" align="left">
                    <b>Send TDS Certificate to NIBM for</b>
                  </div>
                  <div class="Flex_Cell" style="width: 30%" align="right">
                    <b>{{ PaymentDetailsList.tdsAmount }}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="Flex_Row" align="center" valign="middle">
            <div class="Flex_Cell" style="padding: 10px">
              <input
                type="radio"
                v-model="invoiceTypeID"
                id="rblTaxInvoice"
                name="invoiceTypeID"
                value="1"
                v-if="PaymentStatus == 1"
              />
              <label for="rblTaxInvoice" v-if="PaymentStatus == 1"
                >Tax Invoice</label
              >
              <input
                type="radio"
                v-model="invoiceTypeID"
                id="rblPerformaInvoice"
                name="invoiceTypeID"
                value="2"
                v-if="IsApproved == 1"
              />
              <label for="rblPerformaInvoice" v-if="IsApproved == 1"
                >Performa Invoice</label
              >
              <input
                type="radio"
                v-model="invoiceTypeID"
                id="rblPaymentReceipt"
                name="invoiceTypeID"
                value="3"
                v-if="PaymentStatus == 1"
              />
              <label for="rblPaymentReceipt" v-if="PaymentStatus == 1"
                >Payment Receipt</label
              ><br />
              <input
                type="button"
                id="btnPrint"
                name="Print"
                btnName="btnPrint"
                value="Print"
                v-if="IsApproved == 1"
                style="padding: 5px 15px 5px 15px"
                title="Click Here to Print"
                @click="print()"
              />
            </div>
          </div>
          <div
            class="Flex_Row"
            align="center"
            valign="middle"
            v-if="PaymentStatus != 1 && netFeeAmount != 0"
          >
            <div
              class="Flex_Cell"
              align="center"
              style="padding: 10px; width: 80%"
            >
              <input type="checkbox" v-model="tncChecked" id="chkTNC" />
              <label for="chkTNC">I accept the above </label
              ><a style="color: #11ade9" @click="TNCDiv = true"
                >terms and conditions</a
              >
            </div>
          </div>
          <div class="Flex_Row" v-if="tncChecked && PaymentStatus != 1">
            <div class="Flex_Cell" align="center" valign="bottom">
              <AcceptInput
                maxlength="6"
                style="padding-left:0 padding-right:0; width:100px"
                ref="captcha"
                type="textbox"
                v-model="captchaValue2"
                :isRequired="true"
                placeholder="CAPTCHA"
                class="CreateAccount"
                regExp="([0-9])*"
              />&nbsp;&nbsp;
              <img
                id="imgCaptcha2"
                style="border: 1px solid #000"
              />&nbsp;&nbsp;
              <img
                src="../assets/images/refresh.png"
                v-on:click="generateCaptcha()"
                style="
                  cursor: pointer;
                  height: 20px;
                  border: 1px solid #000;
                  border-radius: 50%;
                "
                title="Click here to refresh captcha"
              />
            </div>
          </div>
          <div
            class="Flex_Row"
            align="center"
            v-if="tncChecked && PaymentStatus != 1"
          >
            <div class="Flex_Cell">
              <input
                type="button"
                id="btnPayLater"
                name="btnPayLater"
                btnName="btnPayLater"
                value="Pay Later"
                @click="payLater()"
                style="padding: 5px 30px; margin-left: 10px"
                title="Click here to Payment Later"
                v-if="false"
              />
              <!-- v-if="
                  userTypeID == 1 &&
                  ProgID != -1 &&
                  NomAuthID != -1 &&
                  PaymentMode != 2
                " -->
              <input
                type="button"
                id="btnPayNow"
                name="btnPayNow"
                btnName="btnPayNow"
                value="Pay Now"
                @click="showMessageBoxPayNow()"
                style="padding: 5px 30px; margin-left: 10px"
                title="Click here to Payment Now"
                v-if="
                  userTypeID != -1 &&
                  ProgID != -1 &&
                  NomAuthID != -1 &&
                  PaymentDetailsList.currency == 1
                "
              />
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <ModalPopup
      title="Term & Conditions"
      ref="ModalPopupTNC"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="TNCDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
      class="tblEntryForm"
    >
      <div class="Flex_Table tblEntryForm">
        <div class="Flex_Row">
          <div class="Flex_Cell GridFlex" style="display: none">
            <fieldset style="min-height: 290px">
              <legend>Instructions</legend>
              <ul style="text-align: left; margin-top: 5px; margin-left: 15px">
                <li class="payinstruction">
                  Application Fee to be paid online while submitting the
                  application form is Rs. 2000/- which is inclusive of
                  application fee, service charges and GST.
                </li>
                <li class="payinstruction">
                  The final payable amount will also include convenience fee /
                  online transaction charges as levied by Payment Gateway
                  depending on the mode of payment.
                </li>
                <li class="payinstruction">
                  Payment of the above cost to be made on-line through Credit
                  Card, Debit Card or Net Banking at the “Proceed to Pay”
                  button.
                </li>
                <li class="payinstruction">
                  Please ensure all mandatory fields are filled up with
                  appropriate information before making payment.
                </li>
                <li class="payinstruction">
                  Receipt will be provided for Rs. 2000/-. It will not include
                  convenience fee / online transaction charges levied by the
                  payment gateway.
                </li>
                <li class="payinstruction">
                  Applicants are required to keep the receipt safely and present
                  copy of the same whenever required.
                </li>
              </ul>
            </fieldset>
          </div>
          <div class="Flex_Cell GridFlex">
            <fieldset style="min-height: 290px">
              <legend>Terms and Conditions</legend>
              <ul
                style="text-align: left; margin-left: 15px; margin-bottom: 20px"
              >
                <li class="payinstruction">
                  All entries made in this application form are true and correct
                  to the best of my knowledge and belief. Mistakes on account of
                  wrong entries/typing error will be my sole responsibility.
                </li>
                <li class="payinstruction">
                  Instances of any incorrect information and process violation
                  detected at any stage of the selection process will lead to my
                  disqualification from the selection process.
                </li>
                <li class="payinstruction">
                  I understand that the application fees once paid cannot be
                  refunded in any circumstances.
                </li>
              </ul>
            </fieldset>
          </div>
        </div>
      </div>
    </ModalPopup>
    <img
      src="../assets/images/NIBMFees.jpg"
      style="display: none"
      id="NIBMFees"
    />
    <img src="../assets/images/header.png" style="display: none" id="header" />
    <img
      src="../assets/images/nibm-water-mark.jpg"
      style="display: none"
      id="bg"
    />
    <img src="../assets/images/Circle.png" style="display: none" id="circle" />
    <img
      src="../assets/images/Circlecheck.png"
      style="display: none"
      id="circlecheck"
    /><img
      src="../assets/images/QRCodeForNIBMPayment.png"
      style="display: none"
      id="imgqrCode"
    />
  </div>
</template>
<script>
import AcceptInput from "./ekkControls/AcceptInput.vue";
import DateControl from "./ekkControls/DateControl.vue";
import LoginJS from "./serviceJS/loginjs.js";
import PaymentJS from "./serviceJS/paymentJS.js";
import ModalPopup from "./ekkControls/ModalPopup";
export default {
  name: "PaymentOption",
  props: {
    userTypeID: { required: true },
    ProgID: { required: true },
    NomAuthID: { required: true },
    NominationCode: { required: true },
    FinYearID: { required: true },
    PaymentStatus: { required: true },
    PaymentMode: { required: true },
    IsApproved: { required: true },
  },
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput,
    ModalPopup: ModalPopup,
  },
  data() {
    return {
      isDisclamer: false,
      captchaKey2: "",
      captchaValue2: "",
      tncChecked: false,
      PaymentDetailsList: [],
      TNCDiv: false,
      FeeRecieptDiv: false,
      invoiceTypeID: -1,
      netFeeAmount: 0,
    };
  },
  methods: {
    modalPopupShown(e) {
      //this.printPDFReport();
    },
    modalPopupClosed(e) {
      // this.printbus = new vue();
    },
    print() {
      if (this.invoiceTypeID == 1 || this.invoiceTypeID == 2) {
        this.GetInvoiceDetails(2);
      } else if (this.invoiceTypeID == 3) {
        if (this.PaymentMode == 1) {
          this.GetPaymentReceipt(1);
        } else {
          this.GetPaymentReceipt(2);
        }
      }
    },
    printData(_html) {
      this.windowPreview;
      if (this.windowPreview != null) {
        this.windowPreview.close();
      }
      this.windowPreview = window.open(
        "",
        "FilePreview",
        "scrollbars,addressbar=no,location=no, resizable=yes,width=800px,height=700px,left=10,top=10"
      );
      this.windowPreview.document.write(_html);
      this.$nextTick(() => {
        this.windowPreview.print();
      });
      // this.windowPreview;
      // if (this.windowPreview != null) {
      //   this.windowPreview.close();
      // }
      // this.windowPreview = window.open(
      //   "",
      //   "FilePreview",
      //   "scrollbars,addressbar=no,location=no, resizable=yes,width=900px,height=700px,left=10,top=10"
      // );
      // this.windowPreview.document.write(_html);
      this.invoiceTypeID = -1;
    },
    GetPaymentReceipt(type) {
      const _data_ = {
        NomineeID: this.NomAuthID,
        Type: type,
      };
      PaymentJS.GetPaymentReceipt(_data_).then(
        (response) => {
          if (response.data.isSuccess) {
            var tbl1 = response.data.result[0];
            var tbl2 = response.data.result1[0];
            var tbl3 = response.data.result2[0];
            var amountInWords = response.data.result3;
            let _html = "";

            _html = this.printPaymentReceipt(tbl1, tbl2, tbl3, amountInWords);
            if (_html != "") {
              this.printData(_html);
              // alert(this.numberToWords(412));
            }
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
    GetInvoiceDetails(type) {
      const _data_ = {
        AYearID: this.FinYearID,
        NomineeAuthNo: this.NominationCode,
        IsGSTApplicable: false,
        Type: type,
      };
      PaymentJS.GetInvoiceDetails(_data_).then(
        (response) => {
          if (response.data.isSuccess) {
            let _html = "";
            var tbl1 = [];
            var tbl2 = [];
            if (response.data.result1.length == 0) {
              // console.log(tbl2);
              _html = this.printPerforma(
                this.NominationCode,
                this.PaymentDetailsList
              );
            } else {
              tbl1 = response.data.result[0];
              tbl2 = response.data.result1[0];
              if (tbl2.currency == "1") {
                if (tbl2.countryID == "28" || tbl2.countryID == "154") {
                  _html = this.printFeeInvoiceNB(tbl1, tbl2);
                } else {
                  _html = this.printFeeInvoice(tbl1, tbl2);
                }
              } else {
                _html = this.printFeeInvoiceUSD(tbl1, tbl2);
              }
            }
            if (_html != "") {
              this.printData(_html);
            }
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
    printPerforma(nominationCode, tbl) {
      var _html = "";
      _html += "<html><body>";
      _html += "<style>";
      _html += "@media print";
      _html += "{";
      _html += "body * ";
      _html += "{";
      _html += "visibility: hidden;";
      _html += "}";
      _html += "#printSection,";
      _html += "#printSection * ";
      _html += "{";
      _html += "visibility: visible;";
      _html += "width: 100%;";
      _html += "}";
      _html += "#printSection {";
      _html += "position: relative;";
      _html += "padding: 0px 0px 0px 0px !important;";
      _html += "}";
      _html += "}";
      _html += "font ";
      _html += "{font-size:8pt;";
      _html += "}";
      _html += "DIV.pageClass";
      _html += "{";
      _html += "margin-left: auto;";
      _html += "font-family: Calibri;";
      _html += "padding-top: 20px;";
      _html += "padding-bottom: 20px;";
      _html += "margin-right: auto;";
      _html += "border: 1px solid black;";
      _html += "}";
      _html += "TABLE.BoxDesign TR";
      _html += "{";
      _html += "height: 21px;";
      _html += "}";
      _html += "TABLE.BoxDesign TD";
      _html += "{";
      _html += "BORDER-RIGHT: gray 1px solid;";
      _html += "BORDER-BOTTOM: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "padding-left: 5px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.BoxDesign";
      _html += "{";
      _html += "BORDER-TOP: gray 1px solid;";
      _html += "BORDER-LEFT: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TR";
      _html += "{";
      _html += "height: 15px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TD";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "font-size:15px;";
      _html += "padding-left: 2px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.FormDesign";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "}";
      _html += "TABLE.RoleDesign TR";
      _html += "{";
      _html += "height: 16px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.RoleDesign TD";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "font-size:small;";
      _html += "padding-left: .1px;";
      _html += "overflow-wrap: anywhere;";
      _html += "padding: 4px 10px 4px 10px;";
      _html += "}";
      _html += "TABLE.RoleDesign";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "margin: 20px;";
      _html += "}";
      _html += "P.Page_Break";
      _html += "{";
      _html += "PAGE-BREAK-BEFORE: always;";
      _html += "border-color: gray !important;";
      _html += "}";
      _html += "a.PRINTBTN:hover";
      _html += "{";
      _html += "background-color: rgba(255, 255, 255, 0.2);";
      _html += "}";
      _html += "a.PRINTBTN";
      _html += "{";
      _html +=
        "background-color: #488bda !important;padding: 5px 20px 5px 20px;";
      _html += "color: white;border-radius:5px;";
      _html += "background-image: none;";
      _html += "cursor:pointer";
      _html += "}";
      _html += "</style>";
      _html +=
        "<div align='center' style='width:100%;padding: 5px 0px 15px 10px;'>";
      _html +=
        "<a style='width: 100%;' onclick='window.print();return false;' class='PRINTBTN glyphicons print' >";
      _html += "Print";
      _html += "</a>";
      _html += "</div>";
      _html +=
        "<div class='pageClass bgClass' id='printSection' align='center' style='width:850px'>";
      var bgImg = document.createElement("img");
      var bgnewImg = document.getElementById("bg");
      bgImg.src = bgnewImg.src;
      _html +=
        "<img style='z-index: -1;position: absolute;left: 0;width: 850px;height:100%;right: 0;' src='" +
        bgImg.src +
        "'/>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 15px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td align='right' style='width: 100%'>";
      var newImg = document.createElement("img");
      newImg.style.height = "100px";
      newImg.src = document.getElementById("NIBMFees").src;
      _html += newImg.outerHTML;
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 20px'>";
      _html += "<b>Performa</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html += "<b>Payment for Nomination Code :</b> " + nominationCode + "";
      _html += "</span>";
      _html += "</center>";
      _html +=
        "<table style='width: 97%; margin-top:3px; padding: 0px 20px 0px 20px;' class='RoleDesign'>";
      _html += "<tbody>";
      _html += "<tr style='background-color:lightgrey;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += "<b>Ammount in </b>";
      if (tbl.currency == "1") {
        _html += "&#x20B9;";
      } else if (tbl.currency == "2") {
        _html += "&#36;";
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Total programme fee payable";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.grossFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Original Fee";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.feeAmount_ServiceTax;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html +=
        "Early Bird Incentive (An early bird incentive of " +
        tbl.earlyBird +
        "% is given for those who register 15 days before the start of the programme)";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.earlyBirdAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Discount Amount";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.discountAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td colspan='2' style='width: 100%; text-align: center;'>";
      _html += "<b>Break up of Fee Payable:</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Fees";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.actualFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Add:IGST @ " + tbl.serviceTax + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.serviceTaxAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Add:CGST @ " + tbl.cessServiceTax + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.cessServiceTaxAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Add:SGST @ " + tbl.kK_CESSTax + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.kK_CESSTaxAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Gross Fees";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.grossFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Less: TDS @ " + tbl.tds + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.tdsAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Net fees to be sent to NIBM(Inclusive of GST)";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.netFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr style='background-color:lightyellow;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Please Pay to NIBM";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.netFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr style='background-color:lightyellow;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Send TDS Certificate to NIBM for";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl.tdsAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</div>";
      _html += "</body>";
      _html += "</html>";
      return _html;
    },
    printPaymentReceipt(tbl1, tbl2, tbl3, amountInWords) {
      var _html = "";
      _html = "<html><body>";
      _html += "<style>";
      _html += "@media print";
      _html += "{";
      _html += "body * ";
      _html += "{";
      _html += "visibility: hidden;";
      _html += "}";
      _html += "#printSection,";
      _html += "#printSection * ";
      _html += "{";
      _html += "visibility: visible;";
      _html += "width: 100%;";
      _html += "}";
      _html += "#printSection {";
      _html += "position: relative;";
      _html += "padding: 0px 0px 0px 0px !important;";
      _html += "}";
      _html += "}";
      _html += "font ";
      _html += "{font-size:8pt;";
      _html += "}";
      _html += "DIV.pageClass";
      _html += "{";
      _html += "margin-left: auto;";
      _html += "font-family: Calibri;";
      _html += "padding-top: 20px;";
      _html += "padding-bottom: 20px;";
      _html += "margin-right: auto;";
      _html += "border: 1px solid black;";
      _html += "}";
      _html += "TABLE.BoxDesign TR";
      _html += "{";
      _html += "height: 21px;";
      _html += "}";
      _html += "TABLE.BoxDesign TD";
      _html += "{";
      _html += "BORDER-RIGHT: gray 1px solid;";
      _html += "BORDER-BOTTOM: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "padding-left: 5px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.BoxDesign";
      _html += "{";
      _html += "BORDER-TOP: gray 1px solid;";
      _html += "BORDER-LEFT: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TR";
      _html += "{";
      _html += "height: 15px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TD";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "font-size:15px;";
      _html += "padding-left: 2px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.FormDesign";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "}";
      _html += "TABLE.RoleDesign TR";
      _html += "{";
      _html += "height: 16px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.RoleDesign TD";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "font-size:small;";
      _html += "padding-left: .1px;";
      _html += "overflow-wrap: anywhere;";
      _html += "padding: 4px 10px 4px 10px;";
      _html += "}";
      _html += "TABLE.RoleDesign";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "margin: 20px;";
      _html += "}";
      _html += "P.Page_Break";
      _html += "{";
      _html += "PAGE-BREAK-BEFORE: always;";
      _html += "border-color: gray !important;";
      _html += "}";
      _html += "a.PRINTBTN:hover";
      _html += "{";
      _html += "background-color: rgba(255, 255, 255, 0.2);";
      _html += "}";
      _html += "a.PRINTBTN";
      _html += "{";
      _html +=
        "background-color: #488bda !important;padding: 5px 20px 5px 20px;";
      _html += "color: white;border-radius:5px;";
      _html += "background-image: none;";
      _html += "cursor:pointer";
      _html += "}";
      _html += "a.PRINTBTN:hover";
      _html += "{";
      _html += "background-color: rgba(255, 255, 255, 0.2);";
      _html += "}";
      _html += "a.PRINTBTN";
      _html += "{";
      _html +=
        "background-color: #488bda !important;padding: 5px 20px 5px 20px;";
      _html += "color: white;border-radius:5px;";
      _html += "background-image: none;";
      _html += "cursor:pointer";
      _html += "}";
      _html += "</style>";
      _html +=
        "<div align='center' style='width:100%;padding: 5px 0px 15px 10px;'>";
      _html +=
        "<a style='width: 100%;' onclick='window.print();return false;' class='PRINTBTN glyphicons print' >";
      _html += "Print";
      _html += "</a>";
      _html += "</div>";
      _html +=
        "<div class='pageClass bgClass' id='printSection' align='center' style='width:850px'>";
      var bgImg = document.createElement("img");
      var bgnewImg = document.getElementById("bg");
      bgImg.src = bgnewImg.src;
      _html +=
        "<img style='z-index: -1;position: absolute;left: 0;width: 850px;height:100%;right: 0;' src='" +
        bgImg.src +
        "'/>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 15px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td align='left' style='width: 100%'>";
      let newImg = document.createElement("img");
      newImg.style.height = "100px";
      newImg.src = document.getElementById("header").src;
      _html += newImg.outerHTML;
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr style='border-top: solid 1px;border-bottom: solid 1px;'>";
      _html += "<td style='width: 100%'>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 20px'>";
      _html += "<b>RECEIPT</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 100%'>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 16px'>";
      _html += "<b>" + tbl1.forProgramme + "</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 9%'>";
      _html += "<b>Ref. No.</b>";
      _html += "</td>";
      _html += "<td style='width: 1%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 26%'>" + tbl1.nominationCode;
      _html += "</td>";
      _html += "<td style='width: 10%'>";
      _html += "<b>Receipt No.</b>";
      _html += "</td>";
      _html += "<td style='width: 1%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 26%'>";
      _html += tbl3.receiptNo;
      _html += "</td>";
      _html += "<td style='width: 11%'>";
      _html += "<b>Receipt Date</b>";
      _html += "</td>";
      _html += "<td style='width: 1%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 10%'>";
      _html += new Date(tbl3.paymentDate).convertToString("dd/MM/yyyy");
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 100%;padding:19px'>";
      _html +=
        "<span style='color: #054889;font-size: 16px;text-decoration:justify'>";
      _html +=
        "<b>Received with thanks from <span style='text-transform: uppercase;'>" +
        tbl1.nomineeName +
        "</span>" +
        //" the sum of Rupees <span style='text-transform: uppercase;'>" +
        // // commonJS.numberToWords(tbl3.paymentAmount) +
        // amountInWords +
        // "</span>" +
        " for the " +
        tbl2.feeHeadName +
        " for the Programme " +
        tbl1.forProgramme +
        " as per following details:</b>";
      _html += "</span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 97%; margin-top:3px; padding: 0px 20px 0px 20px;' class='RoleDesign'>";
      _html += "<tbody>";
      _html += "<tr style='background-color:lightgrey;'>";
      _html += "<td style='width: 10%; text-align: left;'>";
      _html += "<b>Sr.No.</b>";
      _html += "</td>";
      _html += "<td style='width: 60%; text-align: left;'>";
      _html += "<b>Particulars</b>";
      _html += "</td>";
      _html += "<td style='width: 30%; text-align: right;'>";
      _html += "<b>Amount in ";
      if (tbl3.currencyID == "1") {
        _html += "&#x20B9;</b>";
      } else if (tbl3.currencyID == "2") {
        _html += "&#36;</b>";
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 10%; text-align: left;'>";
      _html += tbl2.srNo;
      _html += "</td>";
      _html += "<td style='width: 60%; text-align: left;'>";
      _html += tbl2.feeHeadName;
      _html += "</td>";
      _html += "<td style='width: 30%; text-align: right;'>";
      _html += tbl2.feeAmount.toFixed(2);
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 10%; text-align: left;'>";
      _html += "</td>";
      _html += "<td style='width: 60%; text-align: right;'>";
      _html += "<b>Total</b>";
      _html += "</td>";
      _html += "<td style='width: 30%; text-align: right;'><b>";
      _html += tbl2.feeAmount.toFixed(2);
      _html += "</b></td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table><br/><br/><br/>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr style='border-top:solid 1px;'>";
      _html += "<td style='width: 100%'>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html += "<b>DETAILS OF PAYMENT MADE TOWARDS FEES</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 97%; margin-top:3px; padding: 0px 20px 0px 20px;' class='RoleDesign'>";
      _html += "<tbody>";
      _html += "<tr style='background-color:lightgrey;'>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += "<b>Payment Mode</b>";
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += "<b>Transaction ID</b>";
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += "<b>Transaction Date</b>";
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: right;'>";
      _html += "<b>Amount in ";
      if (tbl3.currencyID == "1") {
        _html += "&#x20B9;</b>";
      } else if (tbl3.currencyID == "2") {
        _html += "&#36;</b>";
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += tbl3.paymentMode;
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += tbl3.gatewayTransactionID;
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += new Date(tbl3.paymentDate).convertToString("dd/MM/yyyy");
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: right;'>";
      _html += tbl3.paymentAmount.toFixed(2);
      _html += "</td>";
      _html += "</tbody>";
      _html += "</table><br/><br/><br/><br/><br/>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr >";
      _html += "<td style='width: 100%'>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html +=
        "<b>AMOUNT IN WORDS : </b><span style='text-transform: uppercase;'>";
      _html += amountInWords; //commonJS.numberToWords(tbl3.paymentAmount);
      _html += "</span></span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</div>";
      _html += "</body>";
      _html += "</html>";
      return _html;
    },
    printFeeInvoice(tbl1, tbl2) {
      var _html = "";
      _html += "<html><body>";
      _html += "<style>";
      _html += "@media print";
      _html += "{";
      _html += "body * ";
      _html += "{";
      _html += "visibility: hidden;";
      _html += "}";
      _html += "#printSection,";
      _html += "#printSection * ";
      _html += "{";
      _html += "visibility: visible;";
      _html += "width: 100%;";
      _html += "}";
      _html += "#printSection {";
      _html += "position: relative;";
      _html += "padding: 0px 0px 0px 0px !important;";
      _html += "}";
      _html += "}";
      _html += "font ";
      _html += "{font-size:8pt;";
      _html += "}";
      _html += "DIV.pageClass";
      _html += "{";
      _html += "margin-left: auto;";
      _html += "font-family: Calibri;";
      _html += "padding-top: 20px;";
      _html += "padding-bottom: 20px;";
      _html += "margin-right: auto;";
      _html += "border: 1px solid black;";
      _html += "}";
      _html += "TABLE.BoxDesign TR";
      _html += "{";
      _html += "height: 21px;";
      _html += "}";
      _html += "TABLE.BoxDesign TD";
      _html += "{";
      _html += "BORDER-RIGHT: gray 1px solid;";
      _html += "BORDER-BOTTOM: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "padding-left: 5px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.BoxDesign";
      _html += "{";
      _html += "BORDER-TOP: gray 1px solid;";
      _html += "BORDER-LEFT: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TR";
      _html += "{";
      _html += "height: 15px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TD";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "font-size:15px;";
      _html += "padding-left: 2px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.FormDesign";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "}";
      _html += "TABLE.RoleDesign TR";
      _html += "{";
      _html += "height: 16px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.RoleDesign TD";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "font-size:small;";
      _html += "padding-left: .1px;";
      _html += "overflow-wrap: anywhere;";
      _html += "padding: 4px 10px 4px 10px;";
      _html += "}";
      _html += "TABLE.RoleDesign";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "margin: 20px;";
      _html += "}";
      _html += "P.Page_Break";
      _html += "{";
      // _html += "PAGE-BREAK-BEFORE: always;";
      _html += "border-color: gray !important;";
      _html += "}";
      _html += "a.PRINTBTN:hover";
      _html += "{";
      _html += "background-color: rgba(255, 255, 255, 0.2);";
      _html += "}";
      _html += "a.PRINTBTN";
      _html += "{";
      _html +=
        "background-color: #488bda !important;padding: 5px 20px 5px 20px;";
      _html += "color: white;border-radius:5px;";
      _html += "background-image: none;";
      _html += "cursor:pointer";
      _html += "}";
      //_html += 'body { background: rgb(204,204,204); }';
      _html += "* {box-sizing: border-box;padding: 0px;margin: 0px;}";
      _html += 'page[size="A4"] {';
      _html += "background: white;";
      _html += "width: 21cm;";
      //_html += 'height: 29.7cm;';
      _html += "display: block;";
      _html += "margin: 0 auto;";
      _html += "margin-bottom: 0.5cm;";
      _html += "box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);";
      //_html += 'border: 1.25cm solid #000;';
      _html += "border: 1.25cm solid white;";
      _html += "}";
      _html += "</style>";
      _html +=
        "<div align='center' style='width:100%;padding: 5px 0px 15px 10px;'>";
      _html +=
        "<a style='width: 100%;' onclick='window.print();return false;' class='PRINTBTN glyphicons print' >";
      _html += "Print";
      _html += "</a>";
      _html += "</div>";
      _html +=
        "<div class='page pageClass bgClass' id='printSection' align='center' style='width:850px'>";
      var bgImg = document.createElement("img");
      var bgnewImg = document.getElementById("bg");
      bgImg.src = bgnewImg.src;
      _html +=
        "<img style='z-index: -1;position: absolute;left: 0;width: 850px;height:100%;right: 0;' src='" +
        bgImg.src +
        "'/>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 15px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td align='right' style='width: 100%'>";
      var newImg = document.createElement("img");
      newImg.style.height = "80px";
      newImg.src = document.getElementById("NIBMFees").src;
      _html += newImg.outerHTML;
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 20px'>";
      if (this.invoiceTypeID == 1) {
        _html += "<b>Tax Invoice</b>";
      } else {
        _html += "<b>Performa Invoice</b>";
      }
      _html += "</span>";
      _html += "</center>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 60%'>";
      _html += "<table style='margin-top:3px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 35%'>";
      _html += "<b>Ref. No.</b>";
      _html += "</td>";
      _html += "<td style='width: 5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 60%'>" + tbl1.nominationCode;
      _html += "</td>";
      _html += "</tr>";
      _html += "<td style='width: 35%'>";
      _html += "<b>Invoice No.</b>";
      _html += "</td>";
      _html += "<td style='width: 5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 60%'>";
      if (tbl2.invoiceNo != null) {
        _html += tbl2.invoiceNo;
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "<td style='width: 35%'>";
      _html += "<b>Date</b>";
      _html += "</td>";
      _html += "<td style='width: 5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 60%'>";
      if (tbl2.entryDate != null) {
        _html += new Date(tbl2.entryDate).convertToString("dd/MM/yyyy");
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "<td style='width: 40%'>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html += "<center>";
      _html += "<b>Ms. Amruta S Mohile </b>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td>";
      _html += "<center>";
      _html += "<b>Chief Manager (Accounts)</b>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "<b>Bill To</b>";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "<b>Delivered To</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "National Institute of Bank Management";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthName;
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.nomineeName;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "NIBM PO, Kondhwe Khurd,";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthDesig;
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.designation;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "Pune 411048";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthBank + ",";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.bankName;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "Pune";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthAddress;
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.address;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "Maharashtra";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html += "<table style='width: 50%; margin-top:3px;'>";
      _html += "<tbody>";
      _html += "<tr style='background-color: yellow;'>";
      _html += "<td style='width: 35%'><b>GSTIN</b></td>";
      _html += "<td style='width: 5%''><b>:</b></td>";
      _html += "<td style='width: 60%'>27AAATN0040P1ZJ</td>";
      _html += "</tr>";
      _html += "<tr style='background-color: yellow;'>";
      _html += "<td style='width: 35%'><b>PAN No.</b></td>";
      _html += "<td style='width: 5%''><b>:</b></td>";
      _html += "<td style='width: 60%'>AAATN0040P</td>";
      _html += "</tr>";
      _html += "<tr style='background-color: yellow;'>";
      _html += "<td style='width: 35%'><b>SAC CODE</b></td>";
      _html += "<td style='width: 5%''><b>:</b></td>";
      _html += "<td style='width: 60%'>999293</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html += "<b>" + tbl2.courseName + "</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 15px'>";
      _html +=
        "<b>From " +
        new Date(tbl1.fromDate).convertToString("dd/MM/yyyy") +
        " To " +
        new Date(tbl1.toDate).convertToString("dd/MM/yyyy") +
        "</b>";
      _html += "</span>";
      _html += "</center>";
      _html +=
        "<table style='width: 97%; margin-top:3px; padding: 0px 20px 0px 20px;' class='RoleDesign'>";
      _html += "<tbody>";
      _html += "<tr style='background-color:lightgrey;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += "<b>Ammount in </b>";
      if (tbl2.currency == "1") {
        _html += "&#x20B9;";
      } else if (tbl2.currency == "2") {
        _html += "&#36;";
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Total programme fee payable";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.grossFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Original Fee";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.feeAmount_ServiceTax;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html +=
        "Early Bird Incentive (An early bird incentive of " +
        tbl2.earlyBird +
        "% is given for those who register 15 days before the start of the programme)";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.earlyBirdAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Discount Amount";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.discountAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td colspan='2' style='width: 100%; text-align: center;'>";
      _html += "<b>Break up of Fee Payable:</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Fees";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.actualFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Add:IGST @ " + tbl2.serviceTax + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.serviceTaxAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Add:CGST @ " + tbl2.cessServiceTax + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.cessServiceTaxAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Add:SGST @ " + tbl2.kK_CESSTax + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.kK_CESSTaxAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Gross Fees";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.grossFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Less: TDS @ " + tbl2.tds + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.tdsAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Net fees to be sent to NIBM(Inclusive of GST)";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.netFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr style='background-color:lightyellow;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Please Pay to NIBM";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.netFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr style='background-color:lightyellow;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Send TDS Certificate to NIBM for";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.tdsAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html += "Supply in the course &nbsp;&nbsp;";
      var circlecheckImg = document.createElement("img");
      var circlecheckNewImg = document.getElementById("circlecheck");
      circlecheckImg.src = circlecheckNewImg.src;
      _html +=
        "<img style='height:10px;width:10px;vertical-align: middle;' src='" +
        circlecheckImg.src +
        "'>";
      _html += "&nbsp; &nbsp; Intra state trade or commerce &nbsp; &nbsp;";
      var circleImg = document.createElement("img");
      var circleNewImg = document.getElementById("circle");
      circleImg.src = circleNewImg.src;
      _html +=
        "<img style='height:10px;width:10px;vertical-align: middle;' src='" +
        circleImg.src +
        "'>";
      _html += "&nbsp;&nbsp;Inter state trade or commerce";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td>";
      _html += "Tax Liability to be discharged on &nbsp;&nbsp;";
      _html +=
        "<img style='height:10px;width:10px;vertical-align: middle;' src='" +
        circlecheckImg.src +
        "'>";
      _html += "&nbsp;&nbsp;normal charge&nbsp;&nbsp;";
      _html +=
        "<img style='height:10px;width:10px;vertical-align: middle;' src='" +
        circleImg.src +
        "'>";
      _html += "&nbsp;&nbsp;reverse charge";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html += "<b>NIBM BANK DETAILS</b>";
      _html += "</span>";
      _html += "</center>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tr>";
      _html += "<td style='width:20%'>";
      var qrCode = document.createElement("img");
      qrCode.id = "imgqrCode";
      qrCode.src = document.getElementById("imgqrCode").src;
      _html +=
        "<img style='height:100px;width:100px;vertical-align: middle;' src='" +
        qrCode.src +
        "'>";
      _html += "</td>";
      _html += "<td>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td colspan='2'>";
      _html +=
        "Bank of Maharashtra, NIBM Kondhwe Khurd, Kondhwe Khurd, Pune 411048, Maharashtra, India";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width:30%'>";
      _html += "Name of the Account :";
      _html += "</td>";
      _html += "<td>";
      _html += "National Institute of Bank Management";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width:30%'>";
      _html += "Current Account No. :";
      _html += "</td>";
      _html += "<td>";
      _html += "20002400021";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width:30%'>";
      _html += "IFSC Code :";
      _html += "</td>";
      _html += "<td>";
      _html += "MAHB0001124";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width:30%'>";
      _html += "Branch Code :";
      _html += "</td>";
      _html += "<td>";
      _html += "1124";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<br />";
      _html += "<td>";
      _html += "<span style='color: #054889;'>";
      _html += "<b>Amruta S Mohile</b>";
      _html += "</span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<br />";
      _html += "<td>";
      _html += "<span style='color: #054889;'>";
      _html +=
        "<b>If already remitted/on remittance, kindly send the UTR no. details at: accounts@nibmindia.org </b> ";
      _html += "</span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</div>";
      _html += "</body>";
      _html += "</html>";
      return _html;
    },
    printFeeInvoiceUSD(tbl1, tbl2) {
      var _html = "";
      _html = "<html><body>";
      _html += "<style>";
      _html += "@media print";
      _html += "{";
      _html += "body * ";
      _html += "{";
      _html += "visibility: hidden;";
      _html += "}";
      _html += "#printSection,";
      _html += "#printSection * ";
      _html += "{";
      _html += "visibility: visible;";
      _html += "width: 100%;";
      _html += "}";
      _html += "#printSection {";
      _html += "position: relative;";
      _html += "padding: 0px 0px 0px 0px !important;";
      _html += "}";
      _html += "}";
      _html += "font ";
      _html += "{font-size:8pt;";
      _html += "}";
      _html += "DIV.pageClass";
      _html += "{";
      _html += "margin-left: auto;";
      _html += "font-family: Calibri;";
      _html += "padding-top: 20px;";
      _html += "padding-bottom: 20px;";
      _html += "margin-right: auto;";
      _html += "border: 1px solid black;";
      _html += "}";
      _html += "TABLE.BoxDesign TR";
      _html += "{";
      _html += "height: 21px;";
      _html += "}";
      _html += "TABLE.BoxDesign TD";
      _html += "{";
      _html += "BORDER-RIGHT: gray 1px solid;";
      _html += "BORDER-BOTTOM: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "padding-left: 5px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.BoxDesign";
      _html += "{";
      _html += "BORDER-TOP: gray 1px solid;";
      _html += "BORDER-LEFT: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TR";
      _html += "{";
      _html += "height: 15px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TD";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "font-size:15px;";
      _html += "padding-left: 2px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.FormDesign";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "}";
      _html += "TABLE.RoleDesign TR";
      _html += "{";
      _html += "height: 16px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.RoleDesign TD";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "font-size:small;";
      _html += "padding-left: .1px;";
      _html += "overflow-wrap: anywhere;";
      _html += "padding: 4px 10px 4px 10px;";
      _html += "}";
      _html += "TABLE.RoleDesign";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "margin: 20px;";
      _html += "}";
      _html += "P.Page_Break";
      _html += "{";
      _html += "PAGE-BREAK-BEFORE: always;";
      _html += "border-color: gray !important;";
      _html += "}";
      _html += "a.PRINTBTN:hover";
      _html += "{";
      _html += "background-color: rgba(255, 255, 255, 0.2);";
      _html += "}";
      _html += "a.PRINTBTN";
      _html += "{";
      _html +=
        "background-color: #488bda !important;padding: 5px 20px 5px 20px;";
      _html += "color: white;border-radius:5px;";
      _html += "background-image: none;";
      _html += "cursor:pointer";
      _html += "}";
      _html += "</style>";
      _html +=
        "<div align='center' style='width:100%;padding: 5px 0px 15px 10px;'>";
      _html +=
        "<a style='width: 100%;' onclick='window.print();return false;' class='PRINTBTN glyphicons print' >";
      _html += "Print";
      _html += "</a>";
      _html += "</div>";
      _html +=
        "<div class='pageClass' id='printSection' align='center' style='width:850px'>";
      var bgImg = document.createElement("img");
      var bgnewImg = document.getElementById("bg");
      bgImg.src = bgnewImg.src;
      _html +=
        "<img style='z-index: -1;position: absolute;left: 0;width: 850px;height:100%;right: 0;' src='" +
        bgImg.src +
        "'/>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 15px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td align='right' style='width: 100%'>";
      var newImg = document.createElement("img");
      newImg.style.height = "100px";
      newImg.src = document.getElementById("NIBMFees").src;
      _html += newImg.outerHTML;
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 20px'>";
      if (this.invoiceTypeID == 1) {
        _html += "<b>Tax Invoice</b>";
      } else {
        _html += "<b>Performa Invoice</b>";
      }
      _html += "</span>";
      _html += "</center>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 60%'>";
      _html += "<table style='margin-top:3px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 35%'>";
      _html += "<b>Ref. No.</b>";
      _html += "</td>";
      _html += "<td style='width: 5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 60%'>" + tbl1.nominationCode;
      _html += "</td>";
      _html += "</tr>";
      _html += "<td style='width: 35%'>";
      _html += "<b>Invoice No.</b>";
      _html += "</td>";
      _html += "<td style='width: 5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 60%'>";
      _html += tbl2.invoiceNo;
      _html += "</td>";
      _html += "</tr>";
      _html += "<td style='width: 35%'>";
      _html += "<b>Date</b>";
      _html += "</td>";
      _html += "<td style='width: 5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 60%'>";
      _html += new Date(tbl2.entryDate).convertToString("dd/MM/yyyy");
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "<td style='width: 40%'>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html += "<center>";
      _html += "<b>Ms. Amruta S Mohile </b>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td>";
      _html += "<center>";
      _html += "<b>Chief Manager (Accounts)</b>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "<b>Bill To</b>";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "<b>Delivered To</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "National Institute of Bank Management";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthName;
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.nomineeName;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "NIBM PO, Kondhwe Khurd,";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthDesig;
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.designation;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "Pune 411048";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthBank + ",";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.bankName;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "Pune";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthAddress;
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.address;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "Maharashtra";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html += "<table style='width: 50%; margin-top:3px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 35%'><b>GSTIN</b></td>";
      _html += "<td style='width: 5%''><b>:</b></td>";
      _html += "<td style='width: 60%'>27AAATN0040P1ZJ</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 35%'><b>PAN No.</b></td>";
      _html += "<td style='width: 5%''><b>:</b></td>";
      _html += "<td style='width: 60%'>AAATN0040P</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 35%'><b>SAC CODE</b></td>";
      _html += "<td style='width: 5%''><b>:</b></td>";
      _html += "<td style='width: 60%'>999293</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html += "<b>" + tbl2.courseName + "</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 15px'>";
      _html +=
        "<b>From</b> " +
        new Date(tbl1.fromDate).convertToString("dd/MM/yyyy") +
        " <b>To</b> " +
        new Date(tbl1.toDate).convertToString("dd/MM/yyyy");
      _html += "</span>";
      _html += "</center>";
      _html +=
        "<table style='width: 97%; margin-top:3px; padding: 0px 20px 0px 20px;' class='RoleDesign'>";
      _html += "<tbody>";
      _html += "<tr style='background-color:lightgrey;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += "<b>Ammount in </b>";
      if (tbl2.currency == "1") {
        _html += "&#x20B9;";
      } else if (tbl2.currency == "2") {
        _html += "&#36;";
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Total programme fee payable";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.grossFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Original Fee";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.feeAmount_ServiceTax;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td colspan='2' style='width: 100%; text-align: left;'>";
      _html += "<b>" + tbl2.remark + "</b>";
      _html += "</td>";
      _html += "</tr>";
      if (tbl2.discountAmount != "0.00") {
        _html += "<tr>";
        _html += "<td style='width: 65%; text-align: left;'>";
        _html += "Special Discount";
        _html += "</td>";
        _html += "<td style='width: 35%; text-align: right;'>";
        _html += tbl2.discountAmount;
        _html += "</td>";
        _html += "</tr>";
        _html += "<tr>";
        _html += "<td style='width: 65%; text-align: left;'>";
        _html += "Special Discounted Fees Offered";
        _html += "</td>";
        _html += "<td style='width: 35%; text-align: right;'>";
        _html += tbl2.netFeeAmount;
        _html += "</td>";
        _html += "</tr>";
      }
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html +=
        "<b>Fee (net of all FBC/ SWIFT/ Bank Charges) Payable to NIBM</b>";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'><b>";
      _html += tbl2.netFeeAmount;
      _html += "</b></td>";
      _html += "</tr>";
      if (tbl2.offlineFees != "0.00") {
        _html += "<tr>";
        _html += "<td style='width: 65%; text-align: left;'>";
        _html += "Offline Fees";
        _html += "</td>";
        _html += "<td style='width: 35%; text-align: right;'>";
        _html += tbl2.offlineFees;
        _html += "</td>";
        _html += "</tr>";
      }
      if (tbl2.onlineFees != "0.00") {
        _html += "<tr>";
        _html += "<td style='width: 65%; text-align: left;'>";
        _html += "Online Fees";
        _html += "</td>";
        _html += "<td style='width: 35%; text-align: right;'>";
        _html += tbl2.onlineFees;
        _html += "</td>";
        _html += "</tr>";
      }
      _html += "<tr>";
      _html +=
        "<td colspan='2' style='color: #054889;width: 100%; text-align: left;'>";
      _html +=
        "<b>*FBC / SWIFT Charges / Commission is to be borne by the Bank. NIBM should receive USD " +
        tbl2.netFeeAmount +
        ", net of all the Commission / Charges / Taxes</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html +=
        "<td colspan='4' style='color: #054889;font-size: 18px; text-align:center'>";
      _html += "<b>NIBM NEFT DETAILS</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "1.";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "Name & address of our Bankers";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>Punjab National Bank</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>C-2, Shop no. 4-5</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>Brahma Estate, Kondhwe Khurd</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>Pune 411048 Maharastra, India</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "2.";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "Name of the Account";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += ":";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>NATIONAL INSTITUTE of BANK MANAGEMENT</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "3.";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "3. NIBM's Bank Account No. with Punjab National Bank";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += ":";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>11281131004402</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "4.";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "Bank's SWIFT Code";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += ":";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>PUNBINBBDIB</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "5.";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "Preferred currency";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += ":";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>USD</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "6.";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "Correspondent bank of Punjab National Bank";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += ":";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>WELLS FARGO BANK NA</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "7.";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "Punjab National Bank A/C No. With Correspondent Bank";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += ":";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>2000193007918</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "8.";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "Swift code With Wells Fargo Bank";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += ":";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>PNBPUS3NNYC</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += "9.";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "IFSC";
      _html += "</td>";
      _html += "<td style='width:5%'>";
      _html += ":";
      _html += "</td>";
      _html += "<td style='width:45%'>";
      _html += "<b>PUNB0108810</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<br />";
      _html += "<td>";
      _html += "<span style='color: #054889;'>";
      _html +=
        "<b>Kindly send a confirmatory e-mail at: accounts@nibmindia.org giving details of the remitter and participant, title, dates of programme, remitting bank, country and remittance date along with SWIFT transfer advice.</b> ";
      _html += "</b>";
      _html += "</span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<br />";
      _html += "<td>";
      _html += "<span style='color: #054889;'>";
      _html += "<b>Amruta S Mohile</b>";
      _html += "</span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</div>";
      _html += "</body>";
      _html += "</html>";
      return _html;
    },
    printFeeInvoiceNB(tbl1, tbl2) {
      var _html = "";
      _html = "<html><body>";
      _html += "<style>";
      _html += "@media print";
      _html += "{";
      _html += "body * ";
      _html += "{";
      _html += "visibility: hidden;";
      _html += "}";
      _html += "#printSection,";
      _html += "#printSection * ";
      _html += "{";
      _html += "visibility: visible;";
      _html += "width: 100%;";
      _html += "}";
      _html += "#printSection {";
      _html += "position: relative;";
      _html += "padding: 0px 0px 0px 0px !important;";
      _html += "}";
      _html += "}";
      _html += "font ";
      _html += "{font-size:8pt;";
      _html += "}";
      _html += "DIV.pageClass";
      _html += "{";
      _html += "margin-left: auto;";
      _html += "font-family: Calibri;";
      _html += "padding-top: 20px;";
      _html += "padding-bottom: 20px;";
      _html += "margin-right: auto;";
      _html += "border: 1px solid black;";
      _html += "}";
      _html += "TABLE.BoxDesign TR";
      _html += "{";
      _html += "height: 21px;";
      _html += "}";
      _html += "TABLE.BoxDesign TD";
      _html += "{";
      _html += "BORDER-RIGHT: gray 1px solid;";
      _html += "BORDER-BOTTOM: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "padding-left: 5px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.BoxDesign";
      _html += "{";
      _html += "BORDER-TOP: gray 1px solid;";
      _html += "BORDER-LEFT: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TR";
      _html += "{";
      _html += "height: 15px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TD";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "font-size:15px;";
      _html += "padding-left: 2px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.FormDesign";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "}";
      _html += "TABLE.RoleDesign TR";
      _html += "{";
      _html += "height: 16px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.RoleDesign TD";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "font-size:small;";
      _html += "padding-left: .1px;";
      _html += "overflow-wrap: anywhere;";
      _html += "padding: 4px 10px 4px 10px;";
      _html += "}";
      _html += "TABLE.RoleDesign";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "margin: 20px;";
      _html += "}";
      _html += "P.Page_Break";
      _html += "{";
      _html += "PAGE-BREAK-BEFORE: always;";
      _html += "border-color: gray !important;";
      _html += "}";
      _html += "a.PRINTBTN:hover";
      _html += "{";
      _html += "background-color: rgba(255, 255, 255, 0.2);";
      _html += "}";
      _html += "a.PRINTBTN";
      _html += "{";
      _html +=
        "background-color: #488bda !important;padding: 5px 20px 5px 20px;";
      _html += "color: white;border-radius:5px;";
      _html += "background-image: none;";
      _html += "cursor:pointer";
      _html += "}";
      _html += "a.PRINTBTN:hover";
      _html += "{";
      _html += "background-color: rgba(255, 255, 255, 0.2);";
      _html += "}";
      _html += "</style>";
      _html +=
        "<div align='center' style='width:100%;padding: 5px 0px 15px 10px;'>";
      _html +=
        "<a style='width: 100%;' onclick='window.print();return false;' class='PRINTBTN glyphicons print' >";
      _html += "Print";
      _html += "</a>";
      _html += "</div>";
      _html +=
        "<div id='printSection' class='pageClass bgClass' align='center' style='width:850px'>";
      var bgImg = document.createElement("img");
      var bgnewImg = document.getElementById("bg");
      bgImg.src = bgnewImg.src;
      _html +=
        "<img style='z-index: -1;position: absolute;left: 0;width: 850px;height:100%;right: 0;' src='" +
        bgImg.src +
        "'/>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 15px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td align='right' style='width: 100%'>";
      let newImg = document.createElement("img");
      newImg.style.height = "100px";
      newImg.src = document.getElementById("NIBMFees").src;
      _html += newImg.outerHTML;
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 20px'>";
      if (this.invoiceTypeID == 1) {
        _html += "<b>Tax Invoice</b>";
      } else {
        _html += "<b>Performa Invoice</b>";
      }
      _html += "</span>";
      _html += "</center>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 60%'>";
      _html += "<table style='margin-top:3px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 35%'>";
      _html += "<b>Ref. No.</b>";
      _html += "</td>";
      _html += "<td style='width: 5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 60%'>" + tbl1.nominationCode;
      _html += "</td>";
      _html += "</tr>";
      _html += "<td style='width: 35%'>";
      _html += "<b>Invoice No.</b>";
      _html += "</td>";
      _html += "<td style='width: 5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 60%'>";
      _html += tbl2.invoiceNo;
      _html += "</td>";
      _html += "</tr>";
      _html += "<td style='width: 35%'>";
      _html += "<b>Date</b>";
      _html += "</td>";
      _html += "<td style='width: 5%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 60%'>";
      _html += new Date(tbl2.entryDate).convertToString("dd/MM/yyyy");
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "<td style='width: 40%'>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html += "<center>";
      _html += "<b>Ms. Amruta S Mohile </b>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td>";
      _html += "<center>";
      _html += "<b>Chief Manager (Accounts)</b>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "<b>Bill To</b>";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "<b>Delivered To</b>";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "National Institute of Bank Management";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthName;
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.nomineeName;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "NIBM PO, Kondhwe Khurd,";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthDesig;
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.designation;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "Pune 411048";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthBank + ",";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.bankName;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "Pune";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.payingAuthAddress;
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += tbl1.address;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 33%'>";
      _html += "Maharashtra";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "</td>";
      _html += "<td style='width: 33%'>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html += "<table style='width: 50%; margin-top:3px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 35%'><b>GSTIN</b></td>";
      _html += "<td style='width: 5%''><b>:</b></td>";
      _html += "<td style='width: 60%'>27AAATN0040P1ZJ</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 35%'><b>PAN No.</b></td>";
      _html += "<td style='width: 5%''><b>:</b></td>";
      _html += "<td style='width: 60%'>AAATN0040P</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 35%'><b>SAC CODE</b></td>";
      _html += "<td style='width: 5%''><b>:</b></td>";
      _html += "<td style='width: 60%'>999293</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html += "<b>" + tbl2.courseName + "</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 15px'>";
      _html +=
        "<b>From " +
        new Date(tbl1.fromDate).convertToString("dd/MM/yyyy") +
        " To " +
        new Date(tbl1.toDate).convertToString("dd/MM/yyyy") +
        "</b>";
      _html += "</span>";
      _html += "</center>";
      _html +=
        "<table style='width: 97%; margin-top:3px; padding: 0px 20px 0px 20px;' class='RoleDesign'>";
      _html += "<tbody>";
      _html += "<tr style='background-color:lightgrey;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += "<b>Amount in ";
      if (tbl2.currency == "1") {
        _html += "&#x20B9;</b>";
      } else if (tbl2.currency == "2") {
        _html += "&#36;</b>";
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Total programme fee payable";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.grossFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Original Fee";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.feeAmount_ServiceTax;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html +=
        "Early Bird Incentive (An early bird incentive of " +
        tbl2.earlyBird +
        "% is given for those who register 15 days before the start of the programme)";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.earlyBirdAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Discount Amount";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.discountAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "<b>Break up of Fee Payable:</b>";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += "";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Fees";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.actualFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Add:IGST @ " + tbl2.serviceTax + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.serviceTaxAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Add:CGST @ " + tbl2.cessServiceTax + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.cessServiceTaxAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Add:SGST @ " + tbl2.kK_CESSTax + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.kK_CESSTaxAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Gross Fees";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.grossFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Less: TDS @ " + tbl2.tds + "%";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.tdsAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Net fees to be sent to NIBM(Inclusive of GST)";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.netFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr style='background-color:lightyellow;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Please Pay to NIBM";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.netFeeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr style='background-color:lightyellow;'>";
      _html += "<td style='width: 65%; text-align: left;'>";
      _html += "Send TDS Certificate to NIBM for";
      _html += "</td>";
      _html += "<td style='width: 35%; text-align: right;'>";
      _html += tbl2.tdsAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html +=
        "(* TDS, if any deductible, should be grossed up and borne by the Bank. NIBM Should receive Indian ";
      _html += "&#x20B9;";
      _html += tbl2.netFeeAmount + "/- net of TDS)";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html += "<b>NIBM BANK DETAILS</b>";
      _html += "</span>";
      _html += "</center>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html +=
        "Bank of Maharashtra, NIBM Kondhwe Khurd, Kondhwe Khurd, Pune 411048, Maharashtra, India";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td>";
      _html += "Name of the Account :";
      _html += "</td>";
      _html += "<td>";
      _html += "National Institute of Bank Management";
      _html += "</td>";
      _html += "<td>";
      _html += "Current Account No. :";
      _html += "</td>";
      _html += "<td>";
      _html += "20002400021";
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td>";
      _html += "IFSC Code :";
      _html += "</td>";
      _html += "<td>";
      _html += "MAHB0001124";
      _html += "</td>";
      _html += "<td>";
      _html += "Branch Code :";
      _html += "</td>";
      _html += "<td>";
      _html += "1124";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<br /><br /><br />";
      _html += "<td>";
      _html += "<span style='color: #054889;'>";
      _html +=
        "<b>If already remitted/on remittance, kindly send the UTR no. details at: accounts@nibmindia.org </b> ";
      _html += "</b>";
      _html += "</span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<br /><br />";
      _html += "<td>";
      _html += "<span style='color: #054889;'>";
      _html += "<b>Amruta S Mohile</b>";
      _html += "</span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</div>";
      _html += "</body>";
      _html += "</html>";
      return _html;
    },
    GetPaymentDetails() {
      const _data_ = {
        FinYearID: this.FinYearID,
        NominationCode: this.NominationCode,
        isGSTApplicable: false,
        type: 1,
      };
      PaymentJS.GetPaymentDetails(_data_).then(
        (response) => {
          // console.log(response.data);
          if (response.data.length > 0) {
            this.PaymentDetailsList = response.data[0];
            if (this.PaymentDetailsList.netFeeAmount == "0.00") {
              this.netFeeAmount = 0;
            } else {
              this.netFeeAmount = 1;
            }
            // console.log(this.netFeeAmount);
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
    payLater() {
      if (this.captchaValue2 == "") {
        MessageBox.show({
          message: "Please enter captcha",
          type: "error",
          title: "Error",
        });
        this.captchaValue2 = "";
        this.generateCaptcha();
        return false;
      }
      var AlertMsg =
        "Nomination has been submitted for Pay Later for Prgramme Code: " +
        this.ProgCode +
        " by " +
        this.NomAuthName +
        " Nominating Authority.";
      const _data_ = {
        NomAuthID: this.NomAuthID,
        EarlyBirdPC: this.PaymentDetailsList.earlyBird,
        SpecialDiscountPC: this.PaymentDetailsList.discount,
        captchaKey: this.captchaKey2,
        captchaValue: this.captchaValue2,
        Type: 1,
      };
      PaymentJS.PayLater(_data_).then(
        (response) => {
          // console.log(response.data);
          if (response.data.isSuccess) {
            MessageBox.show({
              message: response.data.msg,
              type: "success",
              title: "Success",
            });
            this.PaymentMode = 2;
          } else {
            MessageBox.show({
              message: response.data.msg,
              type: "error",
              title: "Error",
            });
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
      this.captchaValue2 = "";
      this.generateCaptcha();
    },
    showMessageBoxPayNow() {
      if (this.captchaValue2 == "") {
        MessageBox.show({
          message: "Please enter captcha",
          type: "error",
          title: "Error",
        });
        this.captchaValue2 = "";
        this.generateCaptcha();
        return false;
      }
      MessageBox.show(
        {
          message:
            "You will not be able to modify the nomination after clicking on the payment button",
          type: "confirm",
          title: "",
          defaultButton: 2,
        },
        {
          buttonName: "Ok",
          buttonAction: this.payNow,
        },
        { buttonName: "Cancel", buttonAction: this.clear }
      );
    },
    payNow() {
      if (this.captchaValue2 == "") {
        MessageBox.show({
          message: "Please enter captcha",
          type: "error",
          title: "Error",
        });
        this.captchaValue2 = "";
        this.generateCaptcha();
        return false;
      } else {
        var AlertMsg =
          "Nomination has been submitted and paid for Programme Code: " +
          this.ProgCode +
          " by " +
          this.NomAuthName +
          " Nominating Authority.";
        const _data_ = {
          AlertMsg: AlertMsg,
          captchaKey: this.captchaKey2,
          captchaValue: this.captchaValue2,
        };
        PaymentJS.PayNow(_data_).then(
          (response) => {
            if (response.data.isSuccess) {
              this.$root.$data.NomAuthID = this.NomAuthID;
              this.$root.$data.Discount =
                this.PaymentDetailsList.discountAmount;
              this.$root.$data.EarlyBirdPC =
                this.PaymentDetailsList.earlyBirdAmount;
              this.$root.$data.AlertMsg = response.data.result;
              this.$router.push({ name: "TransRequest" });
            } else {
              MessageBox.show({
                message: response.data.msg,
                type: "error",
                title: "Error",
              });
              this.captchaValue2 = "";
              this.generateCaptcha();
            }
          },
          (error) => {
            if (error.response == undefined) {
              alert("Error: " + error);
            } else {
              alert("Error: " + error.response.statusText);
            }
          },
          (failure) => {
            alert("Failure: " + failure.response);
          }
        );
      }
    },
    generateCaptcha() {
      this.captchaValue1 = "";
      const _data_ = { width: 110, height: 21 };
      LoginJS.GenerateCaptcha(_data_).then(
        (response) => {
          $("#imgCaptcha2").attr("src", response.data.result1);
          this.captchaKey2 = response.data.result;
        },
        (error) => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
  },
  watch: {
    tncChecked(newValue, oldValue) {
      if (this.tncChecked == true) {
        this.generateCaptcha();
      }
    },
    // invoiceTypeID(newValue, oldValue) {
    //   this.GetInvoiceDetails(2);
    // },
  },
  mounted() {
    this.GetPaymentDetails();
    // console.log(this.IsApproved);
    // console.log(this.PaymentMode);
  },
};
</script>
<style scoped>
.tblRow {
  border-bottom: solid 1px darkgray;
  padding-top: 2px;
  padding-bottom: 2px;
}
.instruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 10px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: medium;
  margin-bottom: 6px;
  border-bottom: solid thin darkgrey;
}
.payinstruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 20px;
  line-height: 20px;
  font-size: inherit;
  margin-bottom: 6px;
  /* border-bottom: solid thin darkgrey; */
}
.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}
.GridFlex {
  width: 50%;
  overflow-wrap: anywhere;
}
@media screen and (max-width: 1023px) {
  .GridFlex {
    width: 50%;
    overflow-wrap: anywhere;
  }
}
@media screen and (max-width: 800px) {
  .GridFlex {
    width: 100%;
    overflow-wrap: anywhere;
  }
}
@media screen and (max-width: 600px) {
  .GridFlex {
    width: 100%;
    overflow-wrap: anywhere;
  }
}
@media screen and (max-width: 480px) {
  .GridFlex {
    width: 100%;
    overflow-wrap: anywhere;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PaymentOption.vue